/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyzedBrick
 */
export interface AnalyzedBrick {
    /**
     * Teilenummer oder ID
     * @type {string}
     * @memberof AnalyzedBrick
     */
    id: string;
    /**
     * Beschreibung
     * @type {string}
     * @memberof AnalyzedBrick
     */
    description: string;
    /**
     * Ist geschützt?
     * @type {boolean}
     * @memberof AnalyzedBrick
     */
    _protected: boolean;
    /**
     * Details zum Schutz
     * @type {string}
     * @memberof AnalyzedBrick
     */
    protectionDetails: string;
}

/**
 * Check if a given object implements the AnalyzedBrick interface.
 */
export function instanceOfAnalyzedBrick(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "_protected" in value;
    isInstance = isInstance && "protectionDetails" in value;

    return isInstance;
}

export function AnalyzedBrickFromJSON(json: any): AnalyzedBrick {
    return AnalyzedBrickFromJSONTyped(json, false);
}

export function AnalyzedBrickFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyzedBrick {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'],
        '_protected': json['protected'],
        'protectionDetails': json['protectionDetails'],
    };
}

export function AnalyzedBrickToJSON(value?: AnalyzedBrick | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'protected': value._protected,
        'protectionDetails': value.protectionDetails,
    };
}

